import ru from './locales/ru.json';
import tr from './locales/tr.json';
import pt from './locales/pt.json';
import ko from './locales/ko.json';
import es from './locales/es.json';
import th from './locales/th.json';
import vi from './locales/vi.json';
import fr from './locales/fr.json';
import zh from './locales/zh.json';
import de from './locales/de.json';
import id from './locales/id.json';
import it from './locales/it.json';
import ja from './locales/ja.json';
import pl from './locales/pl.json';
import uk from './locales/uk.json';
import fa from './locales/fa.json';
import { updatesPhrases } from './updatesPhrases';

// Only bundled, reviewed text is executable. Tenant labels are plain metadata.
export const phraseCatalogs = Object.fromEntries(Object.entries({ ru, tr, pt, ko, es, th, vi, fr, zh, de, id, it, ja, pl, uk, fa })
  .map(([code, phrases]) => [code, { ...updatesPhrases[code], ...phrases }]));
export const supportedLanguages = [
  { code: 'en', name: 'English US', locale: 'en-US', direction: 'ltr' },
  { code: 'ru', name: 'Русский', locale: 'ru-RU', direction: 'ltr' },
  { code: 'tr', name: 'Türkçe', locale: 'tr-TR', direction: 'ltr' },
  { code: 'pt', name: 'Português', locale: 'pt-BR', direction: 'ltr' },
  { code: 'ko', name: '한국어', locale: 'ko-KR', direction: 'ltr' },
  { code: 'ar', name: 'العربية', locale: 'ar-SA', direction: 'rtl' },
  { code: 'es', name: 'Español', locale: 'es-ES', direction: 'ltr' },
  { code: 'th', name: 'ไทย', locale: 'th-TH', direction: 'ltr' },
  { code: 'vi', name: 'Tiếng Việt', locale: 'vi-VN', direction: 'ltr' },
  { code: 'fr', name: 'Français', locale: 'fr-FR', direction: 'ltr' },
  { code: 'zh', name: '中文', locale: 'zh-CN', direction: 'ltr' },
  { code: 'de', name: 'Deutsch', locale: 'de-DE', direction: 'ltr' },
  { code: 'id', name: 'Bahasa Indonesia', locale: 'id-ID', direction: 'ltr' },
  { code: 'it', name: 'Italiano', locale: 'it-IT', direction: 'ltr' },
  { code: 'ja', name: '日本語', locale: 'ja-JP', direction: 'ltr' },
  { code: 'pl', name: 'Polski', locale: 'pl-PL', direction: 'ltr' },
  { code: 'uk', name: 'Українська', locale: 'uk-UA', direction: 'ltr' },
  { code: 'fa', name: 'فارسی', locale: 'fa-IR', direction: 'rtl' },
];

export const directionFor = code => supportedLanguages.find(language => language.code === code)?.direction || 'ltr';
